/* eslint-disable max-len */
import gql from 'graphql-tag';
import apollo from '../apollo';

const REMOVE_SUPER_LINK_MUTATION = gql`
  mutation($input: DeleteSuperLinkInput!) {
    deleteSuperLink(input: $input) {
      superLinkId
    }
  }
`;

export const removeSuperLink = input => apollo
  .mutate({
    mutation: REMOVE_SUPER_LINK_MUTATION,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const SEND_SUPERLINK_EMAIL_INVITE = gql`
  mutation sendSuperLinkEmailInvitations($input: SuperLinkGenericMutationInput!) {
    sendSuperLinkEmailInvitations(input: $input)
  }
`;

export const sendSuperLinkEmailInvitations = input => apollo
  .mutate({
    mutation: SEND_SUPERLINK_EMAIL_INVITE,
    variables: {
      input,
    },
    refetchQueries: ['getSuperlinkAssessments'],
  })
  .then(res => res.data);

const SEND_SUPERLINK_EMAIL_REMINDER = gql`
  mutation sendSuperLinkEmailReminders($input: SuperLinkGenericMutationInput!) {
    sendSuperLinkEmailReminders(input: $input)
  }
`;

export const sendSuperLinkEmailReminders = input => apollo
  .mutate({
    mutation: SEND_SUPERLINK_EMAIL_REMINDER,
    variables: {
      input,
    },
    refetchQueries: ['getSuperlinkAssessments'],
  })
  .then(res => res.data);

const ADD_SUPER_LINK_MUTATE = gql`
  mutation($input: CreateSuperLinkInput!) {
    createSuperLink(input: $input) {
      superLink {
        id
        respondentType
      }
    }
  }
`;

export const createSuperLink = input => apollo
  .mutate({
    mutation: ADD_SUPER_LINK_MUTATE,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const UPDATE_SUPERLINK = gql`
  mutation updateSuperLink($input: UpdateSuperLinkInput!) {
    updateSuperLink(input: $input) {
      superLink {
        id
        name
        description
        notes
        sendRespondentReport
        printFriendlyReport
        locale
        reports
        targetJob {
          id
          name
        }
        activationOptions {
          enabled
          activationType
          numberOfAssessmentsToDisableAfter
        }
      }
    }
  }
`;

export const updateSuperLink = input => apollo
  .mutate({
    mutation: UPDATE_SUPERLINK,
    variables: {
      input,
    },
    refetchQueries: ['superLinkDetailQuery'],
  })
  .then(res => res.data);

const UPDATE_SUPER_LINK_ASSESSMENTS_EXPIRATION_TIME = gql`
  mutation updateSuperLinkAssessmentsExpirationTime($input: UpdateSuperLinkAssessmentsExpirationTimeInput!) {
    updateSuperLinkAssessmentsExpirationTime(input: $input) {
      superLinkId
    }
  }
`;

export const updateSuperLinkAssessmentsExpirationTime = input => apollo
  .mutate({
    mutation: UPDATE_SUPER_LINK_ASSESSMENTS_EXPIRATION_TIME,
    variables: {
      input,
    },
  })
  .then(res => res.data);

const RESET_STATUS_UPDATE_SUPER_LINK_ASSESSMENTS_EXPIRATION_TIME = gql`
  mutation resetStatusAndUpdateSuperLinkAssessmentsExpirationTime($input: UpdateSuperLinkAssessmentsExpirationTimeInput!) {
    resetStatusAndUpdateSuperLinkAssessmentsExpirationTime(input: $input) {
      superLinkId
    }
  }
`;

export const resetStatusAndUpdateSuperLinkAssessmentsExpirationTime = input => apollo
  .mutate({
    mutation: RESET_STATUS_UPDATE_SUPER_LINK_ASSESSMENTS_EXPIRATION_TIME,
    variables: {
      input,
    },
    refetchQueries: ['getSuperlinkAssessments'],
  })
  .then(res => res.data);

const REMOVE_ASSESSMENT = gql`
  mutation removeAssessmentFromSuperLink($input: RemoveAssessmentFromSuperLinkInput!) {
    removeAssessmentFromSuperLink(input: $input)
  }
`;

export const removeAssessmentFromSuperLink = input => apollo
  .mutate({
    mutation: REMOVE_ASSESSMENT,
    variables: {
      input,
    },
    refetchQueries: ['getSuperlinkAssessments'],
  })
  .then(res => res.data);
